var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contact-info"}},[_c('CardFormItem',{attrs:{"title":"Email","description":_vm.email},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('span',{staticClass:"icon-edit-outline",on:{"click":function($event){_vm.showModalMail = true}}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }